import { DateTimeRangeTimezoneComponent } from './date-time-range-timezone.component';

export default angular
  .module('sfMobile.components.date-time-range-timezone', [])
  .component('sfDateTimeRangeTimezone', DateTimeRangeTimezoneComponent).name;
